import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { EmbeddedHost } from '../shared/embedded-host.js';
import '../shared/sdb-overlay-element.js';
import './sdb-preview-dialog.js';

@customElement('sdb-embedded-preview-dialog')
class SdbEmbeddedPreviewDialog extends EmbeddedHost(LitElement) {

    // The dialog registers its overlay right away; it only opens once the store
    // asks it to, so there is nothing to gate on `ready` here.
    render() {
        return html`
            <sdb-overlay-element id="sdb-preview-dialog">
                <sdb-preview-dialog></sdb-preview-dialog>
            </sdb-overlay-element>
        `;
    }
}
